import {
  keepPreviousData,
  useQuery,
  UseQueryOptions,
} from '@tanstack/react-query';

import { useForecastsFilterStore } from '@/features/forecasts/hooks/use-forecasts-hub-filter';
import { getFilteredInsightsProjects } from '@/features/insights/api/get-filtered-insights-projects';
import { useCurrentOrg } from '@/features/org/hooks/use-org';
import { Project } from '@/shared/types/api';

type Props = {
  queryProps?: UseQueryOptions<Project[], unknown, Project[]>;
};

export function getFilteredForecastsProjectsQueryKey(orgId?: number) {
  return ['forecastsProjects', 'filtered', orgId];
}

export const useForecastsProjectsFiltered = ({ queryProps }: Props = {}) => {
  const { data: org, isLoading: isOrgLoading } = useCurrentOrg();
  const { projectIds, subprojectIds } = useForecastsFilterStore();

  const filters = {
    projectIds: projectIds?.map((id) => Number(id)),
    subprojectIds: subprojectIds?.map((id) => Number(id)),
  };

  return useQuery({
    ...queryProps,
    placeholderData: keepPreviousData,
    queryKey: [...getFilteredForecastsProjectsQueryKey(org?.id), filters],
    queryFn: async () => {
      if (isOrgLoading || !org) {
        return [];
      }

      return getFilteredInsightsProjects({ orgId: org.id, filters });
    },
    enabled: !isOrgLoading && !!org,
  });
};
